import { createStore } from '@orderx/lab/xr/store';
import { AppCache } from '../services/app-cache';
import { useState, useEffect } from 'react';

const { useStore } = createStore(AppCache.get('isDev') || false);

export function useDev() {
    const [isDev, setIsDev] = useStore();

    function toggleIsDev() {
        const next = !isDev;
        AppCache.set('isDev', next);
        setIsDev(next);
    }

    return {
        isDev,
        toggleIsDev,
        useOnClickListener() {
            const [timesClicked, setTimesClicked] = useState(0);

            useEffect(() => {
                if (timesClicked > 4) {
                    setTimesClicked(0);
                    toggleIsDev();
                }

                const timeout = setTimeout(() => {
                    setTimesClicked(0);
                }, 300);

                return () => clearTimeout(timeout);
            }, [timesClicked]);

            return () => {
                setTimesClicked((timesClicked) => timesClicked + 1);
            };
        },
    };
}
